import { createInertiaApp } from "@inertiajs/react"
import { createElement } from "react"
import { createRoot } from "react-dom/client"
import { AppWrapper } from "../layout/app-wrapper"
import { loadPageComponent } from "bundler/load-page-component"
import Bugsnag from "@bugsnag/js"
import { setInertiaPage } from "core/navigation"

// Function to parse URL and extract the route pattern
const parseUrlToRoute = url => {
  try {
    const urlObj = new URL(url)

    let path = urlObj.pathname

    path = path.replace(/\/\d+/g, "/:id")

    return path
  } catch (error) {
    return url
  }
}

// Add event listener for Inertia invalid events (happens when an Inertia navigation hits a non-Ineria controller)
document.addEventListener("inertia:invalid", event => {
  const toUrl = event.detail.response.request.responseURL

  // Parse URLs to get route patterns
  const toRoute = parseUrlToRoute(toUrl)

  const error = {
    errorClass: "Inertia::InvalidNavigation",
    errorMessage: `Invalid Inertia navigation to a non-inertia page - attempted to navigate to ${toRoute}`
  }

  if (Bugsnag) {
    Bugsnag.notify(error)
    window.location = event.detail.response.request.responseURL // Force a redirect to the non-Inertia page with full page reload
  } else {
    alert(error.errorMessage)
  }
})

setInertiaPage()

createInertiaApp({
  resolve: page => {
    return loadPageComponent(page).then(module => {
      module.default.layout =
        module.default.layout || (page => <AppWrapper>{page}</AppWrapper>)
      return module
    })
  },

  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(createElement(App, props))
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.'
      )
    }
  }
})
